import { Navigate, Outlet } from "react-router-dom";

import { useAuth } from "hooks/useAuth";

const PrivateLayout = () => {
  const { isLoggedIn } = useAuth();

  if (!isLoggedIn) {
    return <Navigate to="/login" replace={true} />;
  }

  return (
    <>
      <Outlet />
    </>
  );
};

export default PrivateLayout;
